import { Marker, Popup } from 'react-leaflet';
import { Icon } from 'leaflet';

const SchoolMarker = ({ school, isSelected, onSelect }) => {


  const schoolIcon = new Icon({
    iconUrl: (isSelected || school.status === 'Ativa')
      ? 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png'
      : 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-grey.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });

  return (

    <Marker
      position={[school.latlng.lat, school.latlng.lng]}
      icon={schoolIcon}
    >
      <Popup>
        <div className="text-center">
          <h3 className="font-semibold text-base">{school.nome_escola || school.name}</h3>

        </div>
      </Popup>
    </Marker>
  );
};

export default SchoolMarker;
